import { getUrl } from './constants'

export const Common = {
  hp: getUrl('hp'),
  'hp-logo': getUrl('hp-logo', 'svg'),
}
